import { ErrorState } from '../../../ui/ErrorState.jsx';
import { BrandedLoading } from '../../auth/components/BrandedLoading.jsx';
import { useSession } from '../../auth/hooks/use-session.js';
import { useProfile } from '../hooks/use-profile.js';
import { OnboardingWizard } from './OnboardingWizard.jsx';

export function ProfileGate({ children }) {
  const { user } = useSession();
  const profile = useProfile();
  // Guarded on `!profile.profile`, not just `status`: `status` flips back to
  // 'loading'/'error' on every background revalidation (tab regains focus, the
  // periodic re-check), not just the first load. Without the guard, that briefly
  // unmounted the whole app - every open panel, every unsaved form - and replaced
  // it with this splash, which is why food logged right as a revalidation landed
  // never reached the server: the form was torn down before it could submit.
  if (profile.status === 'loading' && !profile.profile) return <BrandedLoading displayName={user?.displayName} label="Loading your profile and app data from the database…" />;
  if (profile.status === 'error' && !profile.profile) return <div className="auth-screen"><div className="card auth-screen__card"><ErrorState title="Could not load profile" description={profile.error} onRetry={profile.reload} /></div></div>;
  if (!profile.profile) return <OnboardingWizard onSave={profile.save} />;
  return children;
}
